<template>
  <div class="swipe-handler" ref="swipe">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SwipeHandler',
  data () {
    return {
      xDown: null,
      yDown: null
    }
  },
  methods: {
    handleTouchStart (evt) {
      this.xDown = (evt.touches ? evt.touches[0].clientX : evt.clientX)
      this.yDown = (evt.touches ? evt.touches[0].clientY : evt.clientY)
    },
    handleTouchMove (evt) {
      if (!this.xDown || !this.yDown) {
        return
      }
      let xUp = (evt.touches ? evt.touches[0].clientX : evt.clientX)
      let yUp = (evt.touches ? evt.touches[0].clientY : evt.clientY)
      let xDiff = this.xDown - xUp
      let yDiff = this.yDown - yUp

      if (Math.abs(xDiff) > Math.abs(yDiff)) { /* most significant */
        if (xDiff > 0) {
          /* left swipe */
          this.$emit('swipeLeft')
        } else {
          /* right swipe */
          this.$emit('swipeRight')
        }
      } else {
        if (yDiff > 0) {
          /* up swipe */
          this.$emit('swipeUp')
        } else {
          /* down swipe */
          this.$emit('swipeDown')
        }
      }
      /* reset values */
      this.xDown = null
      this.yDown = null
    }
  },
  mounted: function () {
    this.$refs.swipe.addEventListener('touchstart', this.handleTouchStart, false)
    this.$refs.swipe.addEventListener('touchmove', this.handleTouchMove, false)
    this.$refs.swipe.addEventListener('mousedown', this.handleTouchStart, false)
    this.$refs.swipe.addEventListener('mouseup', this.handleTouchMove, false)
  },
  beforeDestroy: function () {
    this.$refs.swipe.removeEventListener('touchstart', this.handleTouchStart)
    this.$refs.swipe.removeEventListener('touchmove', this.handleTouchMove)
    this.$refs.swipe.addEventListener('mousedown', this.handleTouchStart, false)
    this.$refs.swipe.addEventListener('mouseup', this.handleTouchMove, false)
  }
}
</script>

<style scoped lang="scss">
.swipe-handler {
  user-select: none;
}
</style>
